import ActionTypes from '../../actionTypes'
const { GET_ALL_DATA_FAIL, GET_ALL_DATA_SUCCESS } = ActionTypes.REPORTS.KM_BAD_PINGS

const initialState = {
  allKmBadPings: [],
  dataCount: 0,
}

const kmBadPingsReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case GET_ALL_DATA_SUCCESS:
      return {
        ...state,
        allKmBadPings: payload.rows,
        dataCount: payload.count,
      }
    case GET_ALL_DATA_FAIL:
      return {
        ...state,
        allKmBadPings: [],
        dataCount: 0,
      }
    default:
      return state
  }
}

export default kmBadPingsReducer
